import { GraphQLService } from './graphql-service.ts';
import { PartialAppContext, SsrAppContext } from '../../../shared/source/components/app-context/app-context.tsx';

export type GraphQLServiceType = 'intern' | 'public';

export const createGraphQLService = (
  context: PartialAppContext<SsrAppContext, 'logger'>,
  type: GraphQLServiceType
): GraphQLService => {

  const internEndpoint = Deno.env.get('GRAPHQL_INTERN_ENDPOINT') ?? null;
  const publicEndpoint = Deno.env.get('GRAPHQL_PUBLIC_ENDPOINT') ?? null;

  if(internEndpoint === null || publicEndpoint === null) {
    throw new Error('GraphQL endpoints are not configured. Please check configuration.');
  }

  const endpoints: Record<GraphQLServiceType, string> = {
    intern: internEndpoint,
    public: publicEndpoint,
  };

  return new GraphQLService(context, endpoints[type]);
};